import React, { useState } from "react";
import { experience } from "../data/mock";
import { useReveal } from "../hooks/useReveal";

const SectionHeading = ({ num, title }) => (
  <div className="flex items-center gap-4 mb-12 md:mb-16">
    <h2 className="flex items-baseline gap-3 whitespace-nowrap">
      <span className="font-mono text-accent text-lg md:text-xl">{num}.</span>
      <span className="font-sans text-2xl md:text-3xl font-semibold text-ink tracking-tight">
        {title}
      </span>
    </h2>
    <span className="hidden sm:block h-px flex-1 bg-rule" />
  </div>
);

const Experience = () => {
  const revealRef = useReveal();
  const [active, setActive] = useState(0);
  const job = experience[active];

  return (
    <div className="py-24 md:py-32 border-t border-rule">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div ref={revealRef} className="reveal">
          <SectionHeading num="02" title="Where I've worked" />

          <div className="grid grid-cols-1 md:grid-cols-[220px_1fr] gap-8 md:gap-12">
            {/* Tabs */}
            <div className="relative md:border-l md:border-rule">
              <div
                className="absolute left-0 top-0 w-[2px] bg-accent transition-transform duration-500 hidden md:block"
                style={{
                  height: "44px",
                  transform: `translateY(${active * 44}px)`
                }}
              />
              <div className="flex md:flex-col overflow-x-auto md:overflow-visible scrollbar-none">
                {experience.map((exp, i) => (
                  <button
                    key={exp.id}
                    onClick={() => setActive(i)}
                    className={`shrink-0 md:w-full text-left px-4 md:px-5 h-11 border-b-2 md:border-b-0 border-transparent md:border-l-0 transition-colors font-mono text-xs whitespace-nowrap ${
                      active === i
                        ? "text-accent bg-accent-dim md:bg-transparent border-accent md:border-transparent"
                        : "text-ink-2 hover:text-ink hover:bg-bg-elev"
                    }`}
                  >
                    {exp.company}
                  </button>
                ))}
              </div>
            </div>

            {/* Details */}
            <div key={job.id} className="animate-in fade-in duration-500">
              <h3 className="text-xl md:text-2xl text-ink font-medium tracking-tight">
                {job.position}
                <span className="text-accent"> @ {job.company}</span>
              </h3>
              <p className="font-mono text-xs uppercase tracking-widest text-ink-3 mt-2 mb-6">
                {job.duration} · {job.location}
              </p>

              <ul className="space-y-3 mb-8">
                {job.achievements.map((a, i) => (
                  <li key={i} className="flex gap-3 text-[15px] leading-relaxed text-ink-2">
                    <span className="text-accent font-mono text-sm mt-1 shrink-0">▸</span>
                    <span>{a}</span>
                  </li>
                ))}
              </ul>

              <div className="flex flex-wrap gap-1.5">
                {job.technologies.map((t) => (
                  <span
                    key={t}
                    className="font-mono text-[11px] px-2.5 py-1 rounded-md border border-rule text-ink-2 hover:border-accent/40 hover:text-accent transition-colors"
                  >
                    {t}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Experience;
